import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x14A00000 {
  blockNum: number;
  data: string;
}

export function Command0x14A00000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    blockNum: 0,
    data: "",
  };

  const [fields, setFields] = React.useState<Form0x14A00000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x14A00000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.blockNum) {
      params.blockNum = 0;
    }
    if (!params.data) {
      params.data = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="blockNum"
          label="Номер блока прошивки (нумерация с 1)"
          margin="dense"
          fullWidth
          value={fields.blockNum}
          onChange={handleChangeField("blockNum")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="data"
          label="Блок прикладной программы"
          margin="dense"
          multiline
          fullWidth
          minRows={4}
          value={fields.data}
          onChange={handleChangeField("data")}
        />
      </FormControl>
    </>
  );
}
